module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwM5gImBTDCENLJgE+Ro+azOxMIyi4GB0ZSB4f/pf3/+pP2o4b1J0EYmFtaZ3GwsjBK8HHO4WZmYmFhZpxPrVDNeNuaLzEwMf3nZWS8w/GewIFbjqc+//ur//cfA/PnnXwOgc08SpfHfn9/pX3/9+f/i8/fUr7///AP6MQNdDeMISDkAAQYAS4wzF9UI9sMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/6.png
// module id = 8fvE
// module chunks = 1